/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ProgressInputs */

const en_progress = /** @type {(inputs: ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progress`)
};

const fr_progress = /** @type {(inputs: ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression`)
};

const de_progress = /** @type {(inputs: ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortschritt`)
};

const it_progress = /** @type {(inputs: ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progressi`)
};

const ru_progress = /** @type {(inputs: ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прогресс`)
};

const es_progress = /** @type {(inputs: ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso`)
};

const zh_cn2_progress = /** @type {(inputs: ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进步`)
};

const ja_progress = /** @type {(inputs: ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進捗`)
};

const hi_progress = /** @type {(inputs: ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रगति`)
};

const pt_pt2_progress = /** @type {(inputs: ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso`)
};

/**
* | output |
* | --- |
* | "Progress" |
*
* @param {ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const progress = /** @type {((inputs?: ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_progress(inputs)
	if (locale === "de") return de_progress(inputs)
	if (locale === "it") return it_progress(inputs)
	if (locale === "ru") return ru_progress(inputs)
	if (locale === "es") return es_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_progress(inputs)
	if (locale === "ja") return ja_progress(inputs)
	if (locale === "hi") return hi_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_progress(inputs)
	return en_progress(inputs)
});